module.exports = "/images/ny-life2-4.jpg";